export const EXCHANGES = {
  BINANCE: 'Binance',
  OTHER: 'Otra',
};
